import React, {useEffect} from 'react'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import {useCustomerType, useUsid} from '@salesforce/commerce-sdk-react'
import {Helmet} from 'react-helmet'
import {useLocation} from 'react-router-dom'

const ImpactTracker = () => {
    const {isRegistered, customerType} = useCustomerType()
    const {data: customer} = useCurrentCustomer()
    const {usid} = useUsid()
    const location = useLocation()

    useEffect(() => {
        if (!usid && !customerType) {
            return
        }

        if (isRegistered && (!customer?.hashedLogin || !customer?.customerId)) {
            return
        }

        const scriptLoaded = Array.from(document.scripts).some(
            (s) => s.src === 'https://utt.impactcdn.com/A6253888-377f-4d54-bf02-da56f0bdaf011.js'
        )

        if (scriptLoaded && window.ire && typeof window.ire === 'function') {
            window.ire('identify', {
                customerId: isRegistered && customer?.customerId ? customer.customerId : '',
                customerEmail: isRegistered && customer?.hashedLogin ? customer.hashedLogin : '',
                customProfileId: usid
            })
        }
    }, [usid, customerType, customer?.customerId, customer?.hashedLogin, location.pathname])

    return (
        <Helmet>
            <script type="text/javascript">
                {`
                    (function(a,b,c,d,e,f,g){
                        e['ire_o']=c;
                        e[c]=e[c]||function(){
                            (e[c].a=e[c].a||[]).push(arguments)
                        };
                        f=d.createElement(b);
                        g=d.getElementsByTagName(b)[0];
                        f.async=1;
                        f.src=a;
                        g.parentNode.insertBefore(f,g);
                    })(
                        'https://utt.impactcdn.com/A6253888-377f-4d54-bf02-da56f0bdaf011.js',
                        'script',
                        'ire',
                        document,
                        window
                    );
                `}
            </script>
        </Helmet>
    )
}

export default ImpactTracker
